"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePersonalAutoIncidentSchema = void 0;
const zod_1 = require("zod");
const PersonalAutoIncidentTypeDetails_1 = require("../enums/PersonalAutoIncidentTypeDetails");
const PersonalAutoIncidentTypes_1 = require("../enums/PersonalAutoIncidentTypes");
const AtFaultTypes_1 = require("../enums/AtFaultTypes");
const Incident_1 = require("./Incident");
const constants_1 = require("../constants");
exports.impossiblePersonalAutoIncidentSchema = Incident_1.impossibleIncidentSchema.extend({
    type: zod_1.z.nullable(zod_1.z.nativeEnum(PersonalAutoIncidentTypes_1.PersonalAutoIncidentTypes)),
    typeDetails: zod_1.z.nullable(zod_1.z.nativeEnum(PersonalAutoIncidentTypeDetails_1.PersonalAutoIncidentTypeDetails)),
    driverNameRaw: zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(150).regex(constants_1.REGEX.defaultString).nullable(),
    driver: zod_1.z.number().min(0).max(7).nullable(),
    atFault: zod_1.z.nativeEnum(AtFaultTypes_1.AtFaultTypes),
}).strict();
